import {
  Box,
  Button,
  Popover,
  Stack,
  styled,
  Text,
} from '@ltvco/refresh-lib/theme';

export const StyledNeedAssistanceContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.divider}`,
  width: '100%',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px',
}));

export const StyledNeedAssistanceTitle = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
}));

export const StyledNeedAssistanceContent = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '76px',
  justifyContent: 'space-around',
  alignItems: 'flex-start',
  padding: '0 50px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '20px',
    padding: '0',
  },
}));

export const StyledNeedAssistanceContentButtons = styled(Stack)(
  ({ theme }) => ({
    flexDirection: 'column',
    gap: '20px',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      alignSelf: 'center',
      width: '80%',
    },
  })
);

export const StyledNeedAssistanceContentButton = styled(Button)(
  ({ theme }) => ({
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  })
);

export const LinkButton = styled(Button)({
  textDecoration: 'underline',
  ':hover': { textDecoration: 'underline', backgroundColor: 'inherit' },
  padding: 0,
  lineHeight: 1.2,
});

export const StyledContactInfoStack = styled(Stack)({
  flexDirection: 'column',
  gap: '16px',
});

export const StyledContactRow = styled(Stack)({
  flexDirection: 'row',
  gap: '8px',
});

export const StyledContactContentStack = styled(Stack)({
  flexDirection: 'column',
  gap: '8px',
});

export const StyledContactFormRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: '4px',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '8px',
  },
}));

export const StyledSocialMediaRow = styled(Stack)({
  flexDirection: 'row',
  gap: '8px',
});

export const StyledAdditionalInfoStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
  border: `1px solid ${theme.palette.divider}`,
  padding: '16px',
  gap: '16px',
  alignSelf: 'flex-start',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const StyledLogoutButtonStack = styled(Stack)({
  flexDirection: 'row',
  gap: '16px',
  justifyContent: 'center',
});

export const StyledSubscriptionSettingsPopover = styled(Popover)({});
export const StyledSubscriptionSettingsPopoverContainer = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    width: '273px',
    borderRadius: '8px',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: `0px 1px 1px -1px ${theme.palette.divider}`,
  })
);

export const StyledSubscriptionSettingsPopoverTitleBox = styled(Box)(
  ({ theme }) => ({
    cursor: 'pointer',
    padding: '4px',
    gap: '8px',
    border: 'none',
    background: 'none',
    font: 'inherit',
    appearance: 'none',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
  })
);
